import React from 'react'
import Pool from '../UserPool'
import { useHistory } from 'react-router-dom'
import { CognitoUser, CognitoUserAttribute } from 'amazon-cognito-identity-js'
import { CognitoIdentityServiceProvider } from 'aws-sdk';
export default function Register() {
  const history = useHistory()
  const [value, setValue] = React.useState(false);
  const [loading, setLoading] = React.useState(false)
  const [email, setemail] = React.useState(null)
  const [username, setUsername] = React.useState(null)
  const [password, setPassword] = React.useState(null)
  const [alert, setAlert] = React.useState(false)
  const [alert2, setAlert2] = React.useState(false)
  const [alert3, setAlert3] = React.useState(false)
  const [alert4, setAlert4] = React.useState(false)
  const [alert5, setAlert5] = React.useState(false)
  const [msg, setMsg] = React.useState('Please enter password')
  const [msg1, setMsg1] = React.useState('Please enter username')
  const [msg2, setMsg2] = React.useState('We have sent you a code on your email, please entered that code.')
  const [color, setcolor] = React.useState('red')
  const [msg4, setMsg4] = React.useState('Please enter email')
  const [stage, setStage] = React.useState(1);
  const [Code, setCode] = React.useState(null);
  const [users, setUsers] = React.useState([]);
  const [heading, setheading] = React.useState('Sign Up')
  const [msgtrm, setMsgtrm] = React.useState('User must check box acknowledging agreement to LandBridge Use and Terms')
  const [alert6, setAlert6] = React.useState(false)
  var currentDate = new Date().toLocaleDateString();
  const macAddress = "";
  function handleLogin() {

    history.push('/login')
  }
  const onChange1 = (e) => {
    console.log(e.target.checked);
    setValue(e.target.checked);


  };
  const accessKeyId = atob("QUtJQVNYTkRCQkVONTIzTVhTRVM=");
  const secretAccessKey = atob("SXlxOHRGRDFCd0MyYTBjeUhBaXNxYjR1c3FWemJSRnpBL3pwR3Zuag==");
  const cognito = new CognitoIdentityServiceProvider({

    region: 'us-west-2',
    credentials: {
      accessKeyId: accessKeyId,
      secretAccessKey: secretAccessKey,
    },

  });
  const getUser = () => {
    return new CognitoUser({
      Username: username.toLowerCase(),
      Pool
    });
  };
  async function handleRegisterVerify(e) {
    try {
      e.preventDefault();
      if (Code == "" || Code == null) {
        setAlert4(true);
        setMsg4("Please Enter Code");
        return;
      }
      else {
        setLoading(true);
        getUser().confirmRegistration(
          Code,
          true,
          (error, data) => {
            if (error) {
              setMsg2(error.message);
              setAlert3(true);
              setLoading(false);
              return;
            }
            else {
              history.push("/");
              // console.log(data);
              setLoading(false);
            }
          }
        );
      }
    }
    catch
    {
      setAlert3(true)
      setMsg2("Invalid Code");
      setcolor("red");
      setLoading(false)
    }
  }
  async function backregister(e) {
    setStage(1);
    setheading("Sign Up");
  }
  async function termcondition(e) {
    setStage(3);
    setheading("LANDBRIDGE USE AND TERMS");
  }

  async function handleRegister(e) {

    e.preventDefault();
    setAlert2(false);
    setAlert(false);
    setAlert3(false);
    setAlert4(false);
    setAlert5(false);
    setAlert6(false);
    if ((username == "" && password == "") || (username == null && password == null) || (username == "" && password == null) || (username == null && password == "")) {
      setMsg1('Please enter username')
      setMsg('Please enter password')
      setAlert(true);
      setAlert2(true);
    }
    else if (email == "" || email == null) {
      setAlert4(true);
    }
    else if (username == "" || username == null) {
      setAlert(true);
    }
    else if (password == "" || password == null) {
      setMsg('Please enter password')
      setAlert2(true);
    }
    else if (value != true) {
      setMsgtrm('User must check box acknowledging agreement to LandBridge Use and Terms')
      setAlert6(true);
    }
    else {
      //  const res = await axios.get('https://geolocation-db.com/json/')
      //const macAddress = res.data.IPv4;
      //const macAddress = uuid();
      const macAddress = navigator.userAgent;

      // const params = {
      //   UserPoolId: 'us-west-2_1wrdipDKE',
      //   Limit: 0,
      // };


      // const data = await cognito.listUsers(params).promise();
      // setUsers(data.Users);
      //   var isalready=0;
      // {data.Users.map((user) => (
      //   (user.Attributes.find((attr) => attr.Name === 'custom:DeviceKey')!=null?
      //   (user.Attributes.find((attr) => attr.Name === 'custom:DeviceKey').Value!=""?
      //   (user.Attributes.find((attr) => attr.Name === 'custom:DeviceKey').Value == macAddress ?  
      //   isalready=1 : ""):""):"")

      // ))}
      // if(isalready==1)
      // {
      //   setMsg4("Device key already in used to another user.");
      //   setAlert5(true);
      //   setLoading(false);  
      //   return  
      // }
      setLoading(true)
      const attributeList = [
        new CognitoUserAttribute({ Name: 'email', Value: email }),
        new CognitoUserAttribute({ Name: 'custom:RegisterDate', Value: currentDate }),
        new CognitoUserAttribute({ Name: 'custom:PerMonthClick', Value: "15" }),
        new CognitoUserAttribute({ Name: 'custom:UsedClicks', Value: "0" }),
        new CognitoUserAttribute({ Name: 'custom:DeviceKey', Value: macAddress })
        //  new CognitoUserAttribute({ Name: 'custom:UserDefaults ', Value: "false" })
      ];
      Pool.signUp(username, password, attributeList,
        null, (error, data) => {
          if (error) {
            setMsg4(error.message);
            setAlert5(true);
            setLoading(false);
          }
          else {
            setcolor("green");
            setAlert3(true);
            setLoading(false);
            setStage(2);
          }
        });
    }


  }
  return (

    <section class="ftco-section">
      <div class="content">
        <div class="header-area">
          <a href="#"><img src="assets/img/logo.png" alt="logo-singin.png"></img></a>
        </div>

        {stage === 1 && (
          <div class="row wrap d-md-flex">
            <div class="col-md-8 login-wrap">
              <div class="inner_content">
                <div class="d-flex">
                  <div class="w-100">
                    <h3 class="mb-0">{heading}</h3>
                  </div>
                </div>
                {alert5 && <span style={{ color: 'red' }}>{msg4}</span>}

                <form onSubmit={handleRegister} class="signin-form">
                  <h6>
                    {alert3 && (
                      <span style={{ color: color }}>{msg2}</span>
                    )}</h6>
                  <div class="form-group mb-0">
                    <label class="label" for="name">
                      Email{' '}
                      {alert4 && (
                        <span style={{ color: 'red' }}>{msg4}</span>
                      )}
                    </label>
                    <input type="email"
                      value={email}
                      class="form-control"
                      onChange={(e) => setemail(e.target.value)} required />
                  </div>

                  <div class="form-group mb-0">
                    <label class="label" for="name">
                      User name{' '}
                      {alert && (
                        <span style={{ color: 'red' }}>{msg1}</span>
                      )}
                    </label>
                    <input type="text"
                      value={username}
                      class="form-control"
                      onChange={(e) => setUsername(e.target.value)} required />
                  </div>
                  <div class="form-group mb-0">
                    <label class="label" for="password">Password {' '}
                      {alert2 && <span style={{ color: 'red' }}>{msg}</span>}
                    </label>
                    <input type="password"
                      class="form-control"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)} required />
                  </div>
                  <div>
                    <p class="register_content mt-2">
                      <input type="checkbox" checked={value} onChange={onChange1} style={{ marginRight: "1%" }} />
                      I have read, understood and agree to <a onClick={termcondition} href="#" style={{ padding: "0px" }}>Landbridge Terms of Service</a></p>
                    <label>
                      {alert6 && <span style={{ color: 'red' }}>{msgtrm}</span>}</label>
                  </div>
                  <div class="form-group mb-0">
                    <a onClick={handleRegister}>
                      <button type="submit" class="btn btn-primary rounded submit submit_btn">
                        {loading && <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>}
                        Sign Up</button></a>
                  </div>

                </form>
                <p class="text-center register_content">Already have an account? <a onClick={handleLogin} data-toggle="tab" href="#signup">Login Now</a></p>

              </div></div>
            <div class="col-md-4 city-dashboard1 img Landbrige_map" >
              <div class="bg_content">
                <img src="assets/img/LB-Icon-White.svg" alt="LB-Icon-White.svg"></img>
                <h2>land analysis made simple</h2>
              </div>
            </div>
          </div>
        )}
        {stage === 2 && (
          <div class="row wrap d-md-flex">
            <div class="col-md-8 login-wrap">
              <div class="inner_content">
                <div class="d-flex">
                  <div class="w-100">
                    <h3 class="mb-0">Verifications</h3>
                  </div>
                </div>
                {alert5 && <span style={{ color: 'red' }}>{msg4}</span>}

                <form onSubmit={handleRegisterVerify} class="signin-form">
                  <h6>
                    {alert3 && (
                      <span style={{ color: color }}>{msg2}</span>
                    )}</h6>
                  <div class="form-group mb-3">
                    <label class="label" for="name">
                      Verification Code{' '}
                      {alert4 && (
                        <span style={{ color: 'red' }}>{msg4}</span>
                      )}
                    </label>
                    <input type="text"
                      value={Code}
                      class="form-control"
                      onChange={(e) => setCode(e.target.value)} required />
                  </div>
                  <div class="form-group">
                    <a onClick={handleRegisterVerify}>
                      <button type="submit" class="btn btn-primary rounded submit submit_btn">
                        {loading && <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>}
                        Confirm</button></a>
                  </div>

                </form>
                <p class="text-center register_content">Already have an account? <a onClick={handleLogin} data-toggle="tab" href="#signup">Login Now</a></p>

              </div></div>
            <div class="col-md-4 city-dashboard1 img Landbrige_map" >
              <div class="bg_content">
                <img src="assets/img/LB-Icon-White.svg" alt="LB-Icon-White.svg"></img>
                <h2>land analysis made simple</h2>
              </div>
            </div>
          </div>
        )}
        {stage === 3 && (
          <div class="row d-md-flex">
            <div class="col-md-8 login-wrap">
              <div style={{ margin: "5%" }}>
                <div class="d-flex">
                  <div class="w-100 mb-5">
                    <h4 class="mb-0"> <i onClick={backregister} class="fas fa-arrow-left mr-2"></i> {heading}</h4>
                  </div>
                </div>
                <div style={{ overflowY: "auto", height: "95%" }}>


                  <h6>LANDBRIDGE TERMS OF SERVICE</h6>
                  <p>
                    Please read these Terms of Service (this “Agreement”) carefully. Your use of the Site (as defined below) or the Software (as defined below) constitutes your consent to this Agreement.
                  </p><p>
                    This Agreement is between any individual, company or organization that accesses the Site or the Software (“you” or “User”) and LandBridge, LLC (the “Provider” or “we” or “us”) concerning your use of (including any access to) the LandBridge Technology site currently located at https://app.landbridge.tech/ (the “Site”, together with any software, materials or services available therein, the “Software”). This Agreement hereby incorporates by this reference any additional terms and conditions posted by Provider through the Site or Software, or otherwise made available to you by Provider.

                  </p>


                  <h6>1.	USE OF SOFTWARE </h6>
                  <p>
                    <ol type='a'>
                      <li>User agrees and understands that:</li>
                      <ol type="i">
                        <li>
                          The Software is only designed to work for properties within the city of Seattle.
                        </li>
                        <li>
                          The Software is intended for use as a tool for preliminary research and is not intended to be relied upon as a final determination of the feasibility of a property. Provider provides the information and materials via the Software for educational or informational purposes only. The information and materials made available via the Software do not constitute investment advice. Before making investment decisions, User shall verify any information or materials made available via the Software, conduct its own research and arrive at its own conclusions. Any information or materials made available via the Software are not a substitute for User’s due diligence. Provider is not responsible for how User uses information or materials made available via the Software, including without limitation to make investments, or the consequences of any decisions or actions taken in reliance upon, or as a result of, such information or materials. Making decisions based solely on such information or materials should be done only with the knowledge that User could experience losses.
                        </li>
                        <li>
                          Provider does not guarantee, and disclaims all liability and responsibility for, the accuracy or completeness of information or materials made available via the Software. Provider obtains information about properties from various third-party sources, which may include errors or omissions. While Provider endeavors to keep information provided via the Software up-to-date, information provided to Provider is sometimes incomplete or incompatible with Provider’s systems.
                        </li>
                        <li>
                          Users may use the Software to make educated evaluations on a potential development site in the city of Seattle, and to share reports with others for informational purposes only.
                        </li>
                        <li>
                          Users may not make money off of any reports generated by the Software or sublease the Software to anyone else, unless they have (i) entered into an Enterprise license agreement with Provider, or (ii) received written approval from Provider.
                        </li>
                        <li>
                          Users may not use the Software to mislead the public, including inflating pricing, manipulating numbers to deceive the public and/or any other actions that are not in good faith.
                        </li>
                        <li>Users may not share their credentials with others to access the Software. Each user will be able to register one device to have access to the Software.</li>
                      </ol>
                      <li>Users on the Start Up Plan may generate up to 15 property reports. Users on an Enterprise plan may generate unlimited reports. </li>
                      <li>The user's data will be deleted and/or become the property of the provider if they decide to terminate their subscription.</li>
                    </ol>
                  </p>


                  <h6>2.	RULES OF CONDUCT</h6>
                  <p>
                    In connection with the Site or the Software, you must not: </p>
                  <p>
                    <ul>
                      <li>Post, transmit or otherwise make available through or in connection with the Site or the Software any materials that are or may be: (a) threatening, harassing, degrading, hateful or intimidating, or otherwise fail to respect the rights and dignity of others; (b) defamatory, libelous, fraudulent or otherwise tortious; (c) obscene, indecent, pornographic or otherwise objectionable; or (d) protected by copyright, trademark, trade secret, right of publicity or privacy or any other proprietary right, without the express prior written consent of the applicable owner.</li>
                      <li>Post, transmit or otherwise make available through or in connection with the Site or the Software any virus, worm, Trojan horse, Easter egg, time bomb, spyware or other computer code, file or program that is or is potentially harmful or invasive or intended to damage or hijack the operation of, or to monitor the use of, any hardware, software or equipment (each, a “Virus”).</li>
                      <li>Use the Site for any commercial purpose, or use the Site or Software for any purpose that is fraudulent or otherwise tortious or unlawful.</li>
                      <li>Harvest or collect information about users of the Site or the Software.</li>
                      <li>Interfere with or disrupt the operation of the Site, the Software or the servers or networks used to make the Site or the Software available, including by hacking or defacing any portion of the Site or the Software; or violate any requirement, procedure or policy of such servers or networks.</li>
                      <li>Restrict or inhibit any other person from using the Site of the Software.</li>
                      <li>Reproduce, modify, adapt, translate, create derivative works of, sell, rent, lease, loan, timeshare, distribute or otherwise exploit any portion of (or any use of) the Site of the Software except as expressly authorized herein, without Provider’s express prior written consent.</li>
                      <li>Reverse engineer, decompile or disassemble any portion of the Site or the Software, except where such restriction is expressly prohibited by applicable law.</li>
                      <li>Remove any copyright, trademark or other proprietary rights notice from the Site or the Software.</li>
                      <li>Frame or mirror any portion of the Site or the Software, or otherwise incorporate any portion of the Site or the Software into any product or service, without Provider’s express prior written consent.</li>
                      <li>Systematically download and store Site or Software content.</li>
                      <li>Use any robot, spider, site search/retrieval application or other manual or automatic device to retrieve, index, “scrape,” “data mine” or otherwise gather Site content, or reproduce or circumvent the navigational structure or presentation of the Site, without Provider’s express prior written consent. Notwithstanding the foregoing, and subject to compliance with any instructions posted in the robots.txt file located in the Site’s root directory, Provider grants to the operators of public search engines permission to use spiders to copy materials from the Site for the sole purpose of (and solely to the extent necessary for) creating publicly available, searchable indices of such materials, but not caches or archives of such materials. Provider reserves the right to revoke such permission either generally or in specific cases, at any time and without notice. </li>

                    </ul>
                  </p>

                  <p>
                    Users are responsible for obtaining, maintaining and paying for all hardware and all telecommunications and other services needed to use the Site.
                  </p>



                  <h6>3.	PAYMENT TERMS</h6>
                  <p>
                    <ol type='a'>
                      <li>Users will be billed a monthly upfront payment when they sign up for the software. The payment is non-refundable.</li>
                      <li>If a User decides to cancel their subscription, they will have access to the Software until the end of their billing cycle. No refunds will be issued.</li>
                      <li>If a User fails to make a payment, Provider will reach out to the User by email. The User will have 10 business days to make the payment, or they risk losing all their data and account information.</li>
                    </ol>
                  </p>


                  <h6>4.	INTELLECTUAL PROPERTY RIGHTS</h6>
                  <p>
                    <ol type='a'>
                      <li>All intellectual property rights in the Site, the Software and related materials are owned by Provider. All such rights are reserved, and no rights are granted to you except for those expressly granted in this Agreement or, if applicable, other agreement between you and Provider. You may not use our trade names, trademarks, service marks or logos in connection with any product or service that is not ours, or in any manner that is likely to cause confusion. Nothing contained on the Site should be construed as granting any right to use any trade names, trademarks, service marks or logos without the express prior written consent of the owner.</li>
                      <li>Users are granted a limited, non-exclusive, non-sublicenseable, non-transferable license to use the Software on a monthly subscription basis solely for User’s internal business operations, subject to the terms and conditions of this Agreement. </li>
                    </ol>
                  </p>

                  <h6>5.	DISCLAIMER OF WARRANTIES</h6>
                  <p>
                    PROVIDER PROVIDES THE SOFTWARE ON AN “AS IS” AND “AS AVAILABLE” BASIS. NEITHER PROVIDER NOR ANY OF ITS LICENSORS OR SERVICE PROVIDERS WARRANT OR GUARANTEE THAT THE OPERATION OF THE SOFTWARE WILL BE UNINTERRUPTED, VIRUS-FREE OR ERROR-FREE, OR THAT PROVIDER WILL CORRECT ALL SOFTWARES ERRORS, NOR SHALL PROVIDER OR ANY OF ITS SERVICE PROVIDERS BE LIABLE FOR UNAUTHORIZED ALTERATION, THEFT OR DESTRUCTION OF USER’S DATA, FILES, OR PROGRAMS. USER ACKNOWLEDGES THAT PROVIDER DOES NOT CONTROL THE TRANSFER OF DATA OVER COMMUNICATIONS FACILITIES, INCLUDING THE INTERNET, AND THAT THE SOFTWARE MAY BE SUBJECT TO LIMITATIONS, DELAYS, AND OTHER PROBLEMS INHERENT IN THE USE OF SUCH COMMUNICATIONS FACILITIES. TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, PROVIDER AND ITS LICENSORS AND SERVICE PROVIDERS MAKE NO REPRESENTATIONS, WARRANTIES, OR CONDITIONS, EXPRESS OR IMPLIED, AND EXPRESSLY DISCLAIM ANY AND ALL WARRANTIES OR CONDITIONS, EXPRESS, STATUTORY, AND IMPLIED, INCLUDING WITHOUT LIMITATION, WARRANTIES OR CONDITIONS OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, WORKMANLIKE EFFORT, ACCURACY OR TITLE, AND WARRANTIES OR CONDITIONS ARISING THROUGH COURSE OF DEALING OR USAGE OF TRADE. NO ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED BY CUSTOMER THROUGH THE SOFTWARE OR ANY MATERIALS AVAILABLE THROUGH THE SOFTWARE WILL CREATE ANY WARRANTY REGARDING PROVIDER OR THE SOFTWARE. USER ASSUMES ALL RISK FOR ANY DAMAGE THAT MAY RESULT FROM ITS USE OF OR ACCESS TO THE SOFTWARE. USER UNDERSTANDS AND AGREES THAT ITS USE OF THE SOFTWARE, AND USE OR OF MATERIALS THROUGH THE SERVICES AND ANY ASSOCIATED SITES OR SERVICES, ARE AT ITS OWN DISCRETION AND RISK.
                  </p>


                  <h6>6.	LIMITATION OF LIABILITY </h6>
                  <p>
                    TO THE FULLEST EXTENT PERMITTED UNDER APPLICABLE LAW:(A) NEITHER PROVIDER NOR ANY LICENSOR OR OTHER SUPPLIER OF PROVIDER SHALL BE LIABLE FOR INDIRECT, INCIDENTAL, SPECIAL OR CONSEQUENTIAL DAMAGES, INCLUDING, WITHOUT LIMITATION, DAMAGES FOR LOST BUSINESS, CONTRACTS, PROFITS, DATA, GOODWILL OR USE OF ANY SERVICE, INCURRED BY EITHER PARTY OR ANY THIRD PARTY IN CONNECTION WITH THIS AGREEMENT, REGARDLESS OF THE NATURE OF THE CLAIM (INCLUDING NEGLIGENCE), EVEN IF FORESEEABLE OR THE OTHER PARTY HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES; (B) WITHOUT LIMITING THE FOREGOING, PROVIDER WILL NOT BE LIABLE FOR DAMAGES OF ANY KIND RESULTING FROM YOUR USE OF OR INABILITY TO USE THE SITE OR SOFTWARE, INCLUDING FROM ANY VIRUS THAT MAY BE TRANSMITTED IN CONNECTION THEREWITH; (C) YOUR SOLE AND EXCLUSIVE REMEDY FOR DISSATISFACTION WITH THE SITE OR SOFTWARE IS TO STOP USING THE SITE OR SOFTWARE; AND (D) THE MAXIMUM AGGREGATE LIABILITY OF PROVIDER FOR ALL DAMAGES, LOSSES AND CAUSES OF ACTION UNDER THIS AGREEMENT, REGARDLESS OF THE NATURE OF THE CLAIM (INCLUDING NEGLIGENCE), SHALL BE THE FEES PAID OR PAYABLE BY USER UNDER THIS AGREEMENT DURING THE THREE (3) MONTHS PRECEDING THE DATE THE CLAIM AROSE.</p>


                  <h6>7.	TERMINATION</h6>
                  <p>
                    <ol type='a'>
                      <li>Provider may terminate this Agreement and the User's access to the Software at any time for any reason, including suspicion of misuse of the Software or violation of the terms of this Agreement.</li>
                      <li>If the User violates any of these terms, Provider may deny access immediately and the User will have no access to their data.</li>
                    </ol>

                  </p>


                  <h6>8.	GENERAL PROVISIONS</h6>
                  <p>
                    <ol type='a'>
                      <li>This Agreement shall be governed by and construed in accordance with the laws of the state of Washington without regard to its conflict of laws provisions and without regard to the United Nations Convention on Contracts for the International Sale of Goods. All disputes arising in connection with this Agreement shall be subject to the sole and exclusive jurisdiction of, and venue in, the state and federal courts located in King County, Washington, and the parties hereby consent to such jurisdiction and venue. </li>
                      <li>This Agreement constitutes the entire agreement between the parties with respect to the subject matter hereof and supersedes all prior or contemporaneous agreements, understandings, or communications between the parties. </li>
                      <li>This Agreement may not be amended except in writing signed by both parties.</li>
                      <li>In the event of a conflict between this Agreement and the Enterprise SaaS Agreement entered into between Provider and User, the Enterprise SaaS Agreement will control.</li>
                      <li>Changes. We may change this Agreement from time to time by notifying you of such changes by any reasonable means, including by posting a revised Agreement through the Site. Any such changes will not apply to any dispute between you and us arising prior to the date on which we posted the revised Agreement incorporating such changes, or otherwise notified you of such changes. Your use of the Site or Software following any changes to this Agreement will constitute your acceptance of such changes. The “Last Updated” legend above indicates when this Agreement was last changed. We may, at any time and without liability, modify or discontinue all or part of the Software (including access to the Software via any third-party links); charge, modify or waive any fees required to use the Software; or offer opportunities to some or all Software users.</li>
                      <li>Technical support is available to Users at any time via email at <a href="mailto:support@landbridge.tech">support@landbridge.tech</a>. </li>

                    </ol>

                  </p>

                </div>


              </div></div>
            <div class="col-md-4 city-dashboard1 img Landbrige_map" >
              <div class="bg_content">
                <img src="assets/img/LB-Icon-White.svg" alt="LB-Icon-White.svg"></img>
                <h2>land analysis made simple</h2>
              </div>
            </div>
          </div>
        )}


      </div>
    </section>

  )
}